import { useEffect, useState } from 'react'
import { useSocket, useStateValue } from 'providers'
import { useGetQuery, usePostQuery } from 'hooks'

// Same shape as games/chat/use-location-chat.js ({ comments, send }) so
// ChatPanel drops in unchanged, but simpler: the socket channel is keyed by
// my own user id (known immediately from session) rather than a fetched
// resource id, and MessageController.create emits to both parties' channels.
export const useDirectMessageChat = (username) => {
  const [
    {
      session: { user }
    }
  ] = useStateValue()
  const [comments, setComments] = useState([])
  const [otherUser, setOtherUser] = useState(null)
  const socket = useSocket()

  const { data, reFetch } = useGetQuery({
    url: `/messages/${username}`,
    enabled: !!username
  })
  const { post: postMessage } = usePostQuery({ url: '/messages' })

  useEffect(() => {
    const messages = data?.messages || []
    setComments(
      messages.map((m) => ({
        id: m.id,
        comment: m.body,
        User: m.Sender
      }))
    )
    setOtherUser(data?.other_user || null)
  }, [data])

  useEffect(() => {
    if (!user?.id) return
    const channel = `/users/${user.id}/messages`
    socket.on(channel, () => {
      setTimeout(() => reFetch(true), 1000)
    })
  }, [socket, user?.id])

  const send = (body) => {
    if (!username || body === '') return
    postMessage({ to_username: username, body })
  }

  return { comments, send, otherUser }
}
